module.exports = __webpack_public_path__ + "static/media/bow.6c0cf5de.png";